import { ActionTypes } from '../../constants/ActionTypes';

// recent image
export const onStartDownloadImage = (imageSrc: string) => {
  return {
    type: ActionTypes.GET_DOWNLOAD_IMAGE,
    payload: imageSrc,
  };
};

export const fetchDownloadImageSuccess = (base64: string) => {
  return {
    type: ActionTypes.FETCH_DOWNLOAD_IMAGE_SUCCESS,
    payload: base64,
  };
};

// recent file
export const onStartDownloadFile = (src: string) => {
  return {
    type: ActionTypes.GET_DOWNLOAD_File,
    payload: src,
  };
};

export const fetchDownloadFileSuccess = (base64: string) => {
  return {
    type: ActionTypes.FETCH_DOWNLOAD_File_SUCCESS,
    payload: base64,
  };
};
